document.addEventListener("DOMContentLoaded", async () => {
  const root = document.querySelector('.data-meama-qr');
  if (!root) return;

  const params = new URLSearchParams(window.location.search);
  const franchiseId = params.get("franchise_id");
  if (!franchiseId) return showError("Missing franchise_id in QR code URL");

  try {
    const meta = await fetchMetaobject(franchiseId);
    if (!meta) return showError("Franchise not found");

    root.querySelector(".qr-loading").classList.add("hidden");
    root.querySelector(".qr-content").classList.remove("hidden");
  } catch (err) {
    showError("Something went wrong loading franchise.");
  }

  async function fetchMetaobject(franchiseId) {
    const query = `
      query getFranchise($handle: String!) {
        metaobject(handle: { handle: $handle, type: "qr_franchise" }) {
          id handle type fields { key value }
        }
      }
    `;
    const res = await fetch("/api/2025-01/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "eab5ef8faedfc8a50490d4df80195f33"
      },
      body: JSON.stringify({ query, variables: { handle: franchiseId } })
    });
    const response = await res.json();
    return response?.data?.metaobject || null;
  }

  const cart = {};

  function updateTotalPrice() {
    let total = 0;
    Object.values(cart).forEach(item => total += item.price * item.quantity);
    const totalEl = document.getElementById("total-price-value");
    if (totalEl) totalEl.innerText = total.toFixed(2) + " ₾";
  }

  document.querySelectorAll(".product-card").forEach(card => {
    const selectBtn = card.querySelector(".select-button");
    const counter = card.querySelector(".qty-counter");
    const qtyValue = card.querySelector(".qty-value");
    const minusBtn = card.querySelector(".qty-minus");
    const plusBtn = card.querySelector(".qty-plus");

    const variantId = card.dataset.productId;
    const priceText = card.querySelector(".price")?.innerText.replace(/[₾, ]/g, '');
    const price = parseFloat(priceText) || 0;
    let quantity = 1;

    selectBtn.addEventListener("click", () => {
      selectBtn.classList.add("hidden");
      counter.classList.remove("hidden");
      cart[variantId] = { price, quantity };
      updateTotalPrice();
    });

    plusBtn.addEventListener("click", () => {
      quantity++;
      qtyValue.innerText = quantity;
      cart[variantId].quantity = quantity;
      updateTotalPrice();
    });

    minusBtn.addEventListener("click", () => {
      if (quantity > 1) {
        quantity--;
        qtyValue.innerText = quantity;
        cart[variantId].quantity = quantity;
      } else {
        counter.classList.add("hidden");
        selectBtn.classList.remove("hidden");
        delete cart[variantId];
        quantity = 1;
        qtyValue.innerText = 1;
      }
      updateTotalPrice();
    });
  });

  const searchInput = document.getElementById("product-search");
  const productCards = document.querySelectorAll(".product-card");
  if (searchInput) {
    searchInput.addEventListener("input", (e) => {
      const query = e.target.value.toLowerCase().trim();
      productCards.forEach(card => {
        const title = card.querySelector(".title")?.innerText.toLowerCase();
        card.style.display = title.includes(query) ? "flex" : "none";
      });
    });
  }

  function showPopup(title, message) {
    const overlay = document.createElement("div");
    overlay.className = "qr-popup-overlay";
    overlay.innerHTML = `
      <div class="qr-popup">
        <h3>${title}</h3>
        <p>${message}</p>
        <button onclick="this.closest('.qr-popup-overlay').remove()">OK</button>
      </div>`;
    document.body.appendChild(overlay);
  }

  async function safeAddToCart(formData) {
    let attempt = 0;
    while (attempt < 2) {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      });
      if (res.status === 429) {
        attempt++;
        await new Promise(r => setTimeout(r, 1500));
        continue;
      }
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || "Add to cart failed");
      return data;
    }
    throw new Error("Too many requests, please try again later.");
  }
  
  async function createKeepzOrder(totalAmount, orderId) {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhZG1pbiIsImlhdCI6MTczNzU2MjQwMCwiZXhwIjoxNzM3NjQ4ODAwfQ.K8mZQp7xVwYjN2FsR4tL6nP9qX3wE5vU8cA1bD7fG2h");

    const raw = JSON.stringify({
      "shop": "https://meama-franchise.myshopify.com/admin/api/2025-01/graphql.json",
      "amount": totalAmount.toString(),
      "integratorOrderId": orderId
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    try {
      const response = await fetch("https://general.meama.ge/api/keepz/order-create", requestOptions);
      
      if (!response.ok) {
        throw new Error(`Keepz API error: ${response.status}`);
      }
      
      const result = await response.json();
      
      const checkoutUrl = result.checkoutUrl || 
      result.data?.checkoutUrl || 
      result.checkout_url ||
      result.data?.checkout_url;
      
      if (!checkoutUrl) {
        throw new Error("No checkout URL in Keepz response");
      }
      
      return checkoutUrl;
    } catch (error) {
      throw error;
    }
  }

  const checkoutBtn = document.getElementById("checkout-btn");

  checkoutBtn.addEventListener("click", async () => {
    if (Object.keys(cart).length === 0) {
      return showPopup("⚠️ გაფრთხილება", "აირჩიეთ პროდუქტი");
    }

    checkoutBtn.disabled = true;
    checkoutBtn.innerText = "Loading...";

    const items = [];
    Object.entries(cart).forEach(([variantId, item]) => {
      if (item.quantity > 0) {
        items.push({ id: Number(variantId), quantity: item.quantity });
      }
    });

    let totalAmount = 0;
    Object.values(cart).forEach(item => totalAmount += item.price * item.quantity);

    const formData = {
      items,
      note: JSON.stringify({ franchiseId })
    };

    try {
      await safeAddToCart(formData);

      const orderId = `${Date.now()}`;
      const checkoutUrl = await createKeepzOrder(totalAmount, orderId);
      
      window.location.href = checkoutUrl;

    } catch (error) {
      showPopup("შეცდომა", error.message || "ცადეთ მოგვიანებით");
      checkoutBtn.disabled = false;
      checkoutBtn.innerText = "Next";
    }
  });

  function showError(message) {
    const alertBox = root.querySelector(".qr-alert");
    if (alertBox) {
      alertBox.innerText = message;
      alertBox.classList.remove("hidden");
    }
    root.querySelector(".qr-loading").classList.add("hidden");
    root.querySelector(".qr-content").classList.add("hidden");
  }
});

